window.customize = window.customize || {};
window.customize.module = window.customize.module || {};

/* ============================================================
main image
============================================================ */
window.customize.module.mainImg = function(imgDirectory, imgFileName) {
  const imgSrc = `${imgDirectory}${window.customize.state.jewelry_id}/main/${imgFileName}.jpg`;
  let html = `
    <div class="p-customizePreviewImg">
      <img src="${imgSrc}" class="js-previewImg">
    </div>
  `;
  return html;
}

/* ============================================================
page
============================================================ */
window.customize.module.question = function(question_item, imgDirectory, isFirstPage, isLastPage) {
  let html = `
    <section class="p-customizePage js-customizePage" data-page="${question_item.id}" style="display: none;">
      <div class="p-customizePage__inner">
        <h2 class="p-customizePage__head">${question_item.name}</h2>
        <p class="p-customizePage__desc">${question_item.description}</p>
        ${window.customize.module.choices(question_item, imgDirectory)}
        <p class="p-customizePage__notice">${question_item.notice}</p>
        ${window.customize.module.price()}
        ${window.customize.module.buttons(question_item, isFirstPage, isLastPage)}
      </div>
    </section>
  `;
  return html;
}

/* ============================================================
step
============================================================ */
window.customize.module.step = function() {
  let listitem = "";

  for (let i = 0, len = window.customize.data.questions.length; i < len; i=(i+1)|0) {
    const data = window.customize.data.questions[i];
    listitem += `
      <li class="p-stepListItem" data-page="${data.id}">
        <div class="p-stepListItem__inner">
          <span class="p-stepListItem__text">${data.shortname}</span>
        </div>
      </li>
    `;
  }

  let html = `
    <section class="p-customizeStep">
      <div class="p-customizeStep__inner">
        <ol class="p-stepList">
          ${listitem}
        </ol>
      </div>
    </section>
  `;
  return html;
}

/* ============================================================
choices
============================================================ */
window.customize.module.choices = function(question_item, imgDirectory) {
  const interlock_input_hidden = question_item.interlock_input_hidden;
  let inputHidden = "";
  if (interlock_input_hidden) {
    inputHidden = `<input type="hidden" name="${interlock_input_hidden}" value=""  data-interlock-input-hidden="${question_item.input_name}">`;
  }

  let html = `<ul class="p-answerList --imgs">`;
  for (let i = 0, len = question_item.choices.length; i < len; i=(i+1)|0) {
    const choice = question_item.choices[i];
    let priceText = "";
    let selected = "";
    let imgSrc = `${imgDirectory}${window.customize.state.jewelry_id}/thumb/${question_item.input_name}_${choice.input_value}.jpg`;

    if (choice.price !== null) {
      priceText = `<br>[¥${choice.price.toLocaleString()}]`;
    }

    if (question_item.is_common_thumb) {
      imgSrc = `${imgDirectory}common/${question_item.input_name}/${question_item.input_name}_${choice.input_value}.jpg`;
    }

    const crtSelectedData = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "id", question_item.id)[0];
    if (crtSelectedData.user_selected){
      if (crtSelectedData.value === choice.input_value) {
        selected = " checked";
      }
    }

    let addItemData = ""
    let conditionalClass = ""
    if (choice.conditional_input_name){
      conditionalClass = "js-conditionalAnswer"
      addItemData += (`data-conditional='${choice.conditional_input_name}:${choice.conditional_input_value}'`)
    }

    html += `
      <li class="p-answerItem ${conditionalClass}" ${addItemData}>
        <label class="p-answerItem__label">
          <input type="radio" name="${question_item.input_name}" value="${choice.input_value}" class="js-selectAnswerInput" required data-question-id="${question_item.id}" data-interlock-input-hidden="${interlock_input_hidden}"${selected} data-ga-event-name="select_radio" data-ga-event-area="choices" data-ga-event-value="${question_item.name}: ${choice.name}">
          <div class="p-selectImg">
            <div class="p-selectImg__img"><img data-src="${imgSrc}" class="js-lazyload" alt="" width="157" height="157"></div>
            <span class="p-selectImg__name">${choice.name}${priceText}</span>
          </div>
        </label>
      </li>
    `;
  }
  html += `</ul>`;
  html += inputHidden;

  return html;
}

window.customize.module.price = function() {
  let html = "";
  html += `
    <h2 class="u-fz-12 u-fw-700 u-mt-50 u-ta-c">${window.customize.language.price.title}</h2>
    <div class="js-nowPrice"></div>
  `;
  return html;
}

/* ============================================================
buttons
============================================================ */
window.customize.module.buttons = function(question_item, isFirstPage, isLastPage) {
  let html = "";
  let disabledDivClass = ' is-disabled';
  let disabledButtonParams = ' aria-disabled="true" tabindex="-1"';
  let submitText = window.customize.language.buttons.add_to_cart;

  if(window.customize.data.settings.can_be_engraved){
    submitText = window.customize.language.buttons.move_to_engraving;
  }

  const crtSelectedData = window.snippets.getObjByKeyValue(window.customize.state.selected_parts, "id", question_item.id)[0];
  if (crtSelectedData.user_selected){
    disabledDivClass = '';
    disabledButtonParams = '';
  }

  const cartButton = `
    <div class="c-button --addCart ${disabledDivClass}">
      <button type="submit" ${disabledButtonParams} class="js-nextButton"data-target-id="carved_seal" data-ga-event-name="add_to_cart" data-ga-event-area="contents_bottom">${submitText}</button>
    </div>
  `;
  const nextButton = `
    <div class="c-button --forward ${disabledDivClass}">
      <button type="button" ${disabledButtonParams} class="js-showPage js-nextButton" data-target="next" data-target-id="${question_item.id+1}" data-ga-event-name="next_step" data-ga-event-area="contents_bottom" data-ga-event-value="${question_item.id+1}">${window.customize.language.buttons.next}</button>
    </div>
  `;
  const prevButton = `
    <div class="c-button --outline">
      <button type="button" class="js-showPage js-nextButton" data-target="prev" data-target-id="${question_item.id-1}" data-ga-event-name="prev_step" data-ga-event-area="contents_bottom" data-ga-event-value="$${question_item.id-1}">${window.customize.language.buttons.prev}</button>
    </div>
  `;

  if (isFirstPage) {
    html = `
      ${nextButton}
    `;
  } else if (isLastPage) {
    html = `
      ${cartButton}
      ${prevButton}
    `;
  } else {
    html = `
      ${nextButton}
      ${prevButton}
    `;
  }

  return html;
}
